export default __webpack_public_path__ + "static/media/discordfrance.37614ebc.png";